import React from "react";
import "./header.css";
import Typed from "react-typed";
import { Link } from "react-router-dom";
import Particle from "./Particle";

const Header = () => {
	return (
		<div id="particles-js" className="header-wrapper ">
			<Particle />
			<div className="main-info d-flex flex-column justify-content-center align-items-center text-center">
				<h1 className="header-title">Welcome!</h1>
				<Typed
					className="typed-text"
					strings={[
						"My name is Marsiya Issah",
						"and I am a Software Engineer",
						"specialized in Generative AI & LLMs",
					]}
					typeSpeed={40}
					backSpeed={60}
					loop
				/>

				<button className="all-btn bttn">
					<Link to="/contact" className="nav-link contact-btn">
						CONTACT ME
					</Link>
				</button>
			</div>
		</div>
	);
};

export default Header;
